/**
 * Product configuration for SnowTrack
 * This constant is used to filter customers and routes by product type
 *
 * Values:
 * - 'lawn' - LawnTrack (lawn care customers)
 * - 'snow' - SnowTrack (snow removal customers)
 * - 'both' - Customers that use both services
 *
 * When filtering:
 * - LawnTrack shows customers with service_type: 'lawn' or 'both'
 * - SnowTrack shows customers with service_type: 'snow' or 'both'
 */
export const PRODUCT_TYPE = 'snow';

/**
 * Helper to build query params with product filter
 * @param {Object} params - Existing query parameters
 * @returns {URLSearchParams} - URLSearchParams with product filter added
 */
export const buildProductParams = (params = {}) => {
  const searchParams = new URLSearchParams(params);
  searchParams.set('product', PRODUCT_TYPE);
  return searchParams;
};

/**
 * Helper to append product filter to existing URL
 * @param {string} url - Base URL (may already have query params)
 * @returns {string} - URL with product filter appended
 */
export const appendProductFilter = (url) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}product=${PRODUCT_TYPE}`;
};
